<!--Begin NavBar CFN-->
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" key="logoutConfirm" acceptLabel="Oui" rejectLabel="Non">
</p-confirmDialog>
<div class="header">
<nav class="navbar navbar-light navbar-expand bg-white shadow mb-4 topbar static-top fixed-top">
  <div class="container-fluid">
    <ul class="nav navbar-nav flex-nowrap ml-auto" style="margin-left: 1px !important;">
      <li class="nav-item dropdown no-arrow">
        <a class="dropdown-toggle nav-link nav-link" data-toggle="dropdown" aria-expanded="false" href="#" (click)="showSideBar()">
          <i class="fas fa-bars text-yellow1"
             style="font-size: 18px;padding: 8px 9px;background-color: #f9f9f9;border-radius: 50px;"></i>
        </a>
        <!--Menu gauche flottant-->
        <app-side-menu *ngIf="slidMenuVisible" (close)="onSideBarClose()" [delayClickOutsideInit]="true" (clickOutside)="slidMenuVisible=false"></app-side-menu>
      </li>
    </ul>
    <div class="d-none d-sm-block topbar-divider"></div>
    <div class="d-sm-flex d-md-flex d-xl-flex align-items-sm-center align-items-xl-center" id="logoBlock"><img src="/assets/v2/img/logo-color-baseline-V62-slogan-black.svg" style="height: 40px;"></div>
    <ul class="nav navbar-nav flex-nowrap ml-auto">
      <li class="nav-item dropdown no-arrow">
        <a class="dropdown-toggle nav-link nav-link" (click)="showAccountMenu()"
           data-toggle="dropdown" aria-expanded="false" href="#">
          <span class="d-none d-lg-inline mr-2" style="color: #222222;">Bonjour</span>
          <span class="d-none d-lg-inline mr-2" style="color: #222222;">{{fullName}}</span>
          <img class="border rounded-circle img-profile" src="assets/v2/img/avatars/profile.png">
        </a>
        <app-account-menu *ngIf="accountMenuVisible" [delayClickOutsideInit]="true"
                          (close)="accountMenuVisible=false" (clickOutside)="accountMenuVisible=false"></app-account-menu>
      </li>
    </ul>

  </div>
</nav>
</div>
